export default [
  {
    path: "/zwzx",
    name: "zwzx",
    component: (resolve) => require(["@/views/PCView/zwzx/index.vue"], resolve),
  },
];
